import React, { useState, useEffect } from 'react'
import AdminBackNavigation from '../../../../components/CommonComponents/AdminBackNavigation';
import AdminSaveHeader from '../../../../components/CommonComponents/AdminSaveHeader';
import Wrapper from '../../../../components/CommonComponents/Wrapper';
import MessageLabel from '../../../../components/CommonComponents/MessageLabel';
import AdminSwitch from '../../../../components/CommonComponents/AdminSwitch';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../../components/Provider/CommonProvider';
import Defaultloadinggif from '../../../../layout/Others/Defaultloadinggif';

const Library_Settings = (adminSetting) => {

    const { fetchRequest } = useMyContext()

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (adminSetting?.adminSetting) {
            const value = {
                enable_library_video: adminSetting.adminSetting.enable_library_video,
                enable_library_audio: adminSetting.adminSetting.enable_library_audio,
                enable_library_trailer: adminSetting.adminSetting.enable_library_trailer,
                enable_library_substitute: adminSetting.adminSetting.enable_library_substitute,
            };
            setData(value);
            setLoading(false)
        } else {
            setData({});
        }
    }, [adminSetting]);

    const handleInput = (e) => {
        const { name, type, checked } = e.target;

        if (type === "checkbox") {
            setData(prev => ({
                ...prev,
                [name]: checked ? 1 : 0
            }))
        }
    };

    const handleUpdate = async () => {
        try {
            setLoading(true)
            const result = await fetchRequest({ method: 'POST', url: `${process.env.REACT_APP_Baseurl}/admin/main-settings/update`, data: data })
            if (result.status) {
                toast.success("Library Settings Updated!")
                setLoading(false)
            }
        } catch (e) {
            toast.error(e?.response?.data?.message || 'Failed to update product type');
        } finally {
            setLoading(false)
        }
    }
    
    if(loading) return <Defaultloadinggif className={"heightOnLoader"} />

    return (
        <>
            <AdminBackNavigation path="/settings" text="Back" />
            <AdminSaveHeader heading="Library Settings" saveText="update" saveMethod={handleUpdate} />

            <Wrapper>
                <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-7 col-md-7 pe-2">
                        <MessageLabel text={`Enable Video`} />
                    </div>
                    <div className="col-5 col-md-5 ps-2 text-end">
                        <AdminSwitch name="enable_library_video" checked={data?.enable_library_video == 1} onChange={handleInput} />
                    </div>
                </div>
                <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-7 col-md-7 pe-2">
                        <MessageLabel text={`Enable Audio`} />
                    </div>
                    <div className="col-5 col-md-5 ps-2 text-end">
                        <AdminSwitch name="enable_library_audio" checked={Number(data?.enable_library_audio) === 1} onChange={handleInput} />
                    </div>
                </div>
                <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-7 col-md-7 pe-2">
                        <MessageLabel text={`Enable Trailer`} />
                    </div>
                    <div className="col-5 col-md-5 ps-2 text-end">
                        <AdminSwitch name="enable_library_trailer" checked={data?.enable_library_trailer == 1} onChange={handleInput} />
                    </div>
                </div>
                <div className="d-flex justify-content-between mb-2 ">
                    <div className="col-7 col-md-7 pe-2">
                        <MessageLabel text={`Enable Substitute`} />
                    </div>
                    <div className="col-5 col-md-5 ps-2 text-end">
                        <AdminSwitch name="enable_library_substitute" checked={data?.enable_library_substitute == 1} onChange={handleInput} />
                    </div>
                </div>
            </Wrapper>
        </>
    )
}


const mapStateToProps = (state) => ({
    adminSetting: state.siteTheme.adminSetting
})
export default connect(mapStateToProps)(Library_Settings)